export default "__VITE_ASSET__efcb404a__"